export * from './qr-code.component';
